module.exports = __webpack_public_path__ + "img/icon_coupon.51828ee8.svg";